<template>
	  <div  >
      <el-card :body-style="cardBodyStyle">
      <el-form label-position="right" label-width="100px" >

				<el-form-item label="请输入旧密码"  >
					<el-input   size="small" v-model="oldPassword" auto-complete="off" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item label="请输入新密码" >
					<el-input  size="small" v-model="newPassword" auto-complete="off" type="password" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item label="请验证新密码" >
					<el-input  size="small" v-model="confirmNewPassword" auto-complete="off" type="password" style="width: 200px;"></el-input>
				</el-form-item>
			 <el-button style="width: 300px;" size="small" type="primary" @click="editPawSubmit">保存</el-button>


	</el-form>
        </el-card>
	 </div>
</template>
<script>
	import axios from '@/axios'
   import tools from '@/tools'
	export default {
		data() {
			return {
          cardBodyStyle: tools.style.card,
				oldPassword: '',
				newPassword: '',
				confirmNewPassword: '',
			}
		},
		methods: {
			editPawSubmit(row) {
				if(this.newPassword != this.confirmNewPassword){
					this.$message({
							type: 'error',
						message: '两次密码输入不一样',
					});
					return;
				}
				var url = 'framework/SysUser/updatePassword.do'
				var param = {
					oldPassword: this.oldPassword,
					newPassword: this.newPassword,
				}
				axios.post(url, param).then(response => {
					if (response.data.code === 0) {
						this.$message({
							type: 'success',
							message: '修改成功!',
						});
					} else {
						this.$message({
							type: 'error',
							message: '修改失败！' + response.data.msg
						});
					}
				});
			}
		},

	}
</script>
<style>



</style>



// WEBPACK FOOTER //
// src/components/system/modifyPassword.vue